import {changeOrdersStatus} from "../reducersFunctions/ordersReducerFunctions";
import {diffArrays} from "../../Utils/DiffUtils";
import {publish} from "../../Events/events";
import {NewOrder, UpdateOrder, DeleteOrder} from "../../Events/topics";

const initialState = {
    deliveryOrders: [],
    fetching: false,
    changing: false,
    fetched: false,
    error: null,
    fetchStartTime: null,
    changeTime: null
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "FETCH_ORDERS_PENDING": {
            return {
                ...state,
                fetching: true,
                fetchStartTime: new Date()
            };
        }
        case "FETCH_ORDERS_FULFILLED": {
            if (state.changeTime !== null && state.fetchStartTime < state.changeTime) {
                return {
                    ...state,
                    fetching: false,
                    deliveryOrders: state.deliveryOrders,
                    error: null
                };
            }

            let newDeliveryOrders = state.deliveryOrders;

            if (state.fetched) {
                const diffOrders = diffArrays(state.deliveryOrders, action.payload, (obj) => obj.id);

                if (diffOrders.length > 0) {
                    for (let diffOrder of diffOrders) {
                        if (diffOrder.type === "add")
                            publish(NewOrder, {order: action.payload.find(o => o.id === diffOrder.id)});
                        else if (diffOrder.type === "remove")
                            publish(DeleteOrder, {order: state.deliveryOrders.find(o => o.id === diffOrder.id)});
                        else if (diffOrder.type === "update")
                            publish(UpdateOrder, {
                                order: action.payload.find(o => o.id === diffOrder.id),
                                changes: diffOrder.changes
                            });
                    }

                    newDeliveryOrders = action.payload;
                }
            } else
                newDeliveryOrders = action.payload;

            return {
                ...state,
                fetching: false,
                deliveryOrders: newDeliveryOrders,
                fetched: true,
                error: null
            };
        }
        case "FETCH_ORDERS_REJECTED": {
            return {
                ...state,
                fetching: false,
                error: action.payload
            };
        }
        case "DELETE_ORDER_PENDING": {
            return {
                ...state,
                deliveryOrders: state.deliveryOrders.filter(order => order.id !== action.meta.orderId),
                changing: true,
                changeTime: new Date()
            }
        }
        case "DELETE_ORDER_FULFILLED": {
            return {
                ...state,
                changing: false
            };
        }
        case "DELETE_ORDER_REJECTED": {
            return {
                ...state,
                changing: false,
                error: action.payload
            };
        }
        case "ADD_ORDER_PENDING": {
            return {
                ...state,
                changing: true,
                changeTime: new Date()
            }
        }
        case "ADD_ORDER_FULFILLED": {
            const orderWithModifiedTime = {
                ...action.meta,
                orderTime: action.payload.data.orderTime,
                sla: action.payload.data.orderSla,
                address: action.payload.data.orderAddress,
                location: action.payload.data.orderLocation
            };

            return {
                ...state,
                deliveryOrders: [...state.deliveryOrders, orderWithModifiedTime],
                changing: false
            };
        }
        case "ADD_ORDER_REJECTED": {
            return {
                ...state,
                changing: false,
                error: action.payload
            };
        }
        case "EDIT_ORDER_PENDING": {
            const newOrders = [...state.deliveryOrders];
            const foundOrderIndex = state.deliveryOrders.findIndex(order => order.id === action.meta.id);
            newOrders[foundOrderIndex] = action.meta;

            return {
                ...state,
                deliveryOrders: newOrders,
                changing: true,
                changeTime: new Date()
            }
        }
        case "EDIT_ORDER_FULFILLED": {
            return {
                ...state,
                changing: false
            };
        }
        case "EDIT_ORDER_REJECTED": {
            return {
                ...state,
                changing: false,
                error: action.payload
            };
        }
        case "REDIRECT_ORDER_PENDING": {
            return {
                ...state,
                deliveryOrders: state.deliveryOrders.map(order => {
                    if (order.id !== action.meta.orderId)
                        return order;

                    return {...order, bid: action.meta.redirectToBid, redirectedFromBid: action.meta.bid}
                }),
                changing: true,
                changeTime: new Date()
            }
        }
        case "REDIRECT_ORDER_FULFILLED": {
            return {
                ...state,
                changing: false
            };
        }
        case "REDIRECT_ORDER_REJECTED": {
            return {
                ...state,
                changing: false,
                error: action.payload
            };
        }
        case "CHANGE_ORDERS_STATUS": {
            const {ordersIds, status} = action.meta;
            const orders = changeOrdersStatus(state.deliveryOrders, ordersIds, status);

            return {
                ...state,
                deliveryOrders: orders,
                changeTime: new Date()
            };
        }
        case "SET_ORDERS_STATUS_PENDING": {
            return {
                ...state,
                changing: true
            };
        }
        case "SET_ORDERS_STATUS_FULFILLED": {
            const {orderIds, status} = action.meta;
            const orders = changeOrdersStatus(state.deliveryOrders, orderIds, status);

            return {
                ...state,
                deliveryOrders: orders,
                changeTime: new Date(),
                changing: false
            };
        }
        case "SET_ORDERS_STATUS_REJECTED": {
            return {
                ...state,
                changing: false,
                error: action.payload
            };
        }
    }

    return state;
}